import { render, staticRenderFns } from "./DashMenu.vue?vue&type=template&id=027a5e7c"
import script from "./DashMenu.vue?vue&type=script&lang=js"
export * from "./DashMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports